/* eslint-disable import/prefer-default-export */
export const dobuta = [
    {
        ivPositivo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia e Viabilidade Miocárdica nas doses de 5, 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECG-BASAL: dentro dos limites da normalidade.
ECG-ESTRESSE: comportamento normal do segmento ST.

ECO-BASAL:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade Miocárdica segmentar com acinesia---; movimento de hipocinesia---.
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
DOBUTA DOSE BAIXA:
- Observado melhora da contratilidade miocárdica ---.
ESTRESSE MÁXIMO:
- Observado ---.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Ausência de Viabilidade Miocárdica ---.
2 - Negativo para indução de Isquemia Miocárdica.`,
    },
    {
        ivNegativo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia e Viabilidade Miocárdica nas doses de 5, 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECG-BASAL: dentro dos limites da normalidade.
ECG-ESTRESSE: comportamento normal do segmento ST.

ECO-BASAL:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade Miocárdica segmentar com acinesia---; movimento de hipocinesia---.
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
DOBUTA DOSE BAIXA:
- Observado melhora da contratilidade miocárdica ---.
ESTRESSE MÁXIMO:
- Observado ---.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Ausência de Viabilidade Miocárdica ---.
2 - Negativo para indução de Isquemia Miocárdica.
`,
    },
    {
        imPositivo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia Miocárdica nas doses de 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECG-BASAL: dentro dos limites da normalidade.
ECG-ESTRESSE: comportamento normal do segmento ST.

ECO-BASAL:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade Miocárdica segmentar normal em repouso.
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE em cada fase, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.

`,
    },
    {
        imNegativo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia Miocárdica nas doses de 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECG-BASAL: dentro dos limites da normalidade.
ECG-ESTRESSE: comportamento normal do segmento ST.

ECO-BASAL:
- Ventrículo Esquerdo com dimensões, funções sistólica e diastólica normais.
- Contratilidade Miocárdica segmentar normal em repouso.
- Índice de volume do átrio esquerdo: --- ml/m² (normal < 34 ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE em cada fase, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.

`,
    },
    {
        imaPositivo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia Miocárdica nas doses de 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECO-BASAL:
- Ventrículo esquerdo com função sistólica preservada.
- Disfunção diastólica do ventrículo esquerdo grau I.
- Hipertrofia ventricular esquerda tipo concêntrica de grau discreto.
- Raiz de Aorta (...) e Aorta Ascendente (...) com aumento discreto.
- Valva mitral exibe refluxo de grau discreto.
- Valva tricúspide exibe refluxo de grau discreto.
- Valva aórtica com folhetos espessados, abertura e mobilidades preservadas. Ao Doppler ausência de gradiente transvalvar significativo.
- Índice de volume do átrio esquerdo:--- ml/m² (normal < 34ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE em cada fase, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

OBSERVAÇÃO:
- Paciente submetido a exame de Ecocardiografia com Estresse Farmacológico em uso de medicação para controle de freqüência cardíaca (.....), fato que pode interferir na acurácia do exame em predizer Isquemia Miocárdica.
CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.

`,
    },
    {
        imaNegativo: `Paciente submetido a ecocardiografia com ESTRESSE FARMACOLÓGICO (DOBUTAMINA) para investigação de Isquemia Miocárdica nas doses de 10, 20, 30 e 40 mcg/Kg, esforço isométrico e atropina 0,5 mg.
Atingiu FC de --- bpm (FCmáx = --- e FCsubmax = ---).
PArepouso = --- mmHg e PAmáxima = --- mmHg.
Ausência de arritmias.
Paciente não referiu sintomatologia significativa.
ECO-BASAL:
- Ventrículo esquerdo com função sistólica preservada.
- Disfunção diastólica do ventrículo esquerdo grau I.
- Hipertrofia ventricular esquerda tipo concêntrica de grau discreto.
- Raiz de Aorta (...) e Aorta Ascendente (...) com aumento discreto.
- Valva mitral exibe refluxo de grau discreto.
- Valva tricúspide exibe refluxo de grau discreto.
- Valva aórtica com folhetos espessados, abertura e mobilidades preservadas. Ao Doppler ausência de gradiente transvalvar significativo.
- Índice de volume do átrio esquerdo:--- ml/m² (normal < 34ml/m²).
- Refluxo Tricúspide. Estimativa da pressão sistólica na artéria pulmonar de --- mmHg.
ESTRESSE MÁXIMO:
- Observado incremento progressivo da contratilidade miocárdica segmentar e da FE em cada fase, sugerindo boa reserva coronariana e ausência de estenose significativa.
Após o término do estresse, observado em repouso a regressão para os padrões basais.
Índice de Contratilidade Regional do VE: --- (Risco de evento cardiovascular: Baixo < 1,1; Intermediário: 1,1 a 1,7; Alto > 1,7)
Em relação ao último exame realizado em ---, não observamos alterações.

OBSERVAÇÃO:
- Paciente submetido a exame de Ecocardiografia com Estresse Farmacológico em uso de medicação para controle de freqüência cardíaca (.....), fato que pode interferir na acurácia do exame em predizer Isquemia Miocárdica.
CONCLUSÃO:
1 - Negativo para indução de Isquemia Miocárdica.

`,
    },
];